import * as React from 'react';

// Assets
import '../Assets/ContactUsPage.sass';

const ContactUs = () => (
    <div className='row'>
        <p className='justify'>This website is currently in the development phase. There are some know bugs, yet
        to be rectified. Some of the major ones are listed under the FAQ session. If you wish to report a bug
        or suggest an enhancement or in general give any feedback, please send an email to <a
                href='mailto:bodhitree.iitb@gmail.com'>bodhitree.iitb@gmail.com</a>. Your feedback will help us
            improve the overall quality and is much appreciated.</p>
        <hr/>

        <div className='row'>
            <address className='col-md-3'>
                <span className='lead'>Kameswari Chebrolu</span><br/>
                <span className='muted'>Department of CSE, IIT Bombay </span><br/>
                <span className='muted'>Powai - 400076</span><br/>
                <span className='muted'>Mumbai.</span><br/>
            </address>
        </div>
    </div>
);

export default ContactUs;
